import React, { useEffect, useState } from "react";
import { ScrollView, View, StyleSheet } from "react-native";
import { IPaginatorViewProps } from "../PaginatorView";
import { onChangeFilters } from "../../helper";
import { DataTable, ImageLoading, PaginatorView } from "../index";
import { THEME_COLORS } from "../../styles";


type sortType = {
    selector: string,
    direction: "desc" | "asc"
}


interface IPaginatedListViewProps extends IPaginatorViewProps {
    columns: any[];
    rightContent?: JSX.Element;
    centerContent?: JSX.Element;
    listData: any;
    loaderView?: JSX.Element;
    sortHandler: (data: sortType[]) => void
    pageHandler: (page: number) => void
    searchHandler: (text: string) => void
    overflowYOffset?: string;
    leftContent?: JSX.Element;
    tableId: string;
    searchedQuery?:string
}

const PaginatedListView = (props: IPaginatedListViewProps) => {
    const { columns, listData, sortHandler, pageHandler, rightContent, centerContent, loaderView,
        leftTextOne, isSearchVisible, paginator, loading, leftContent, searchHandler, overflowYOffset, tableId, isReloadVisible, onReload, fetching } = props;

    return (<View style={{ flexDirection: "row", flex: 1 }}>

        {
            !!leftContent ? leftContent : <></>
        }
        <View style={styles.container}>
            <PaginatorView leftTextOne={leftTextOne}
                isSearchVisible={isSearchVisible}
                centerContent={!!centerContent ? centerContent : <></>}
                onSearchInput={(t) => {
                    searchHandler(t)
                }}
                searchVal={props.searchedQuery}
                paginator={paginator}
                loading={loading}
                loaderView={loaderView}
                isReloadVisible={isReloadVisible}
                onReload={onReload}
                onLeftChevronPress={(page) => pageHandler(page)}
                onRightChevronPress={(page) => pageHandler(page)}
                rightContent={!!rightContent ? rightContent : <></>}
            />
            {fetching ?
                <View style={{ marginTop: 40 }}>
                    <ImageLoading />
                </View>
                :
                <DataTable columns={columns}
                    tableId={tableId}
                    data={listData}
                    overflowYOffset={!!overflowYOffset ? overflowYOffset : '265px'}
                    onClickSort={(selector, sortDirection) => {
                        if (sortDirection) sortHandler([{ selector, direction: sortDirection }]);
                        else sortHandler([]);
                    }}
                />
            }

        </View>
    </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flexShrink: 1,
        paddingHorizontal: 20,
        backgroundColor: THEME_COLORS.white,
        borderRadius: 15,
        paddingVertical: 10,
        // border: "3px solid rgb(235,235,235)",
        // marginTop:30,
        // marginHorizontal:30,
        position: "relative",
        flexGrow: 0,
        width: '100%'
    }
})

export default React.memo(PaginatedListView);
